import { getProcedureRoute } from "@mx/gpl-common";
import Head from "next/head";
import React from "react";
import { ItemList as ItemListSchema, WithContext } from "schema-dts";
import { getPublicRuntimeConfig } from "../../config";
import { getLandingPageUrl } from "../../core/maintainxUrl";
import { IProcedure } from "../../typings/filterEntities";

interface IProps {
  procedures: IProcedure[];
}

const StructuredDataProcedure = ({ procedures }: IProps) => {
  const schema: WithContext<ItemListSchema> = React.useMemo(() => {
    return {
      "@context": "https://schema.org",
      "@type": "ItemList",
      itemListElement: procedures.map((procedure, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: procedure.title,
        url: getLandingPageUrl(
          getPublicRuntimeConfig().basePath +
            "/" +
            getProcedureRoute(procedure.uid, procedure.title),
        ),
      })),
    };
  }, [procedures]);

  return (
    <Head>
      <script defer={true} type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Head>
  );
};

export default StructuredDataProcedure;
